<template>
  <section class="navbar">
    <section class="navbar-left">
      <logo
        v-if="layout !== 'side'"
        :is-collapse="isCollapse"
      />
      <sidebar v-if="layout === 'top'" />
      <breadcrumb v-if="useBreadcrumb"/>
      <ul
        v-if="layout === 'mix'"
        class="project-wrap"
      >
        <li
          v-for="subSys of subsystemList"
          :key="subSys.value"
          :class="['project-item', subSys.value === currentSubsystem ? 'current' : '']"
          @click="changeSubsystem(subSys)"
        >
          {{ subSys.label }}
        </li>
      </ul>
    </section>
    <section class="navbar-right">
      <span
          class="el-dropdown-link el-icon-total"
          @click="handleOpenChat"
      >
          <svg-icon
              icon-class="person-chat"
              class-name="icon__username itsm-icon"
          />
          <span class="icon-label" style="color: #007AF5">快速咨询</span>
        </span>
      <a
          class="el-dropdown-link el-icon-total"
          href="https://idoc.longfor.com/word/wf1DZ3iwdsdgYVqYTCblA79WxmOn"
          target="_blank"
      >
        <svg-icon
            icon-class="itsm"
            class-name="icon__username itsm-icon"
        />
        <span class="icon-label">用户手册</span>
      </a>
<!--      <a-->
<!--          class="el-dropdown-link el-icon-total"-->
<!--          :href="envData.configUrl"-->
<!--          target="_blank"-->
<!--          @click="burialPoint('管理后台')"-->
<!--      >-->
<!--        <svg-icon-->
<!--            icon-class="icon-background-management"-->
<!--            class-name="icon__username help-icon"-->
<!--        />-->
<!--        <span class="icon-label">管理后台</span>-->
<!--      </a>-->
      <el-dropdown trigger="hover" popper-class="nav-btn-list">
        <span class="el-dropdown-link el-icon-total">··· 更多</span>
        <template #dropdown>
          <el-dropdown-menu>
            <el-dropdown-item
                @click="burialPoint('IT报事')"
            >
              <svg-icon
                  icon-class="IT"
                  class-name="icon__username help-icon"
                  @click="openIT"
              />
              <span class="icon-label" @click="openIT">IT报事</span>
            </el-dropdown-item>
            <el-dropdown-item
                @click="burialPoint('公告栏')"
            >
              <svg-icon
                  icon-class="icon-notice-nanbar"
                  class-name="icon__username help-icon"
                  @click="openNotice"
              />
              <span class="icon-label" @click="openNotice">公告栏</span>
            </el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
      <el-divider direction="vertical" />
      <el-dropdown trigger="hover">
        <span class="el-dropdown-link" style="margin-left: 0">
          <svg-icon
            icon-class="username"
            class-name="icon__username"
          />
          <span class="username">{{ userInfo.username || '--' }}</span>
        </span>
        <template #dropdown>
          <el-dropdown-menu>
            <el-dropdown-item
              @click="logoutHandle"
            >
              退出登录
            </el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
<!--      <el-divider direction="vertical" />-->
<!--      <span-->
<!--        id="fullScreen"-->
<!--        class="navbar-right__icon no-pr"-->
<!--        @click="fullscreenToggle"-->
<!--      >-->
<!--        <svg-icon-->
<!--          icon-class="icon-fullscreen"-->
<!--        />-->
<!--      </span>-->
    </section>
    <!-- 公告栏 -->
    <notice-board
        ref="noticeboard"
    />
  </section>
</template>
<script lang="ts">
  import { computed, defineComponent, ref } from 'vue';
  import { useStore } from 'vuex';
  import { useRoute } from 'vue-router';
  import { ElMessage } from 'element-plus';
  import { LOGIN_OUT } from '@/store/actionTypes';
  import { useUserStore } from '@/store/modules/user';
  import { useFullscreen } from '@vueuse/core';
  import Breadcrumb from '../Breadcrumb/index.vue';
  import Sidebar from '../Sidebar/index.vue';
  import Logo from '../Logo/index.vue';
  import envData from "@/utils/env";
  import NoticeBoard from "../NoticeBoard/index.vue";

  export default defineComponent({
    name: 'navbar',
    components: {
      NoticeBoard,
      Breadcrumb,
      Sidebar,
      Logo,
    },
    props: {
      isCollapse: {
        type: Boolean,
        default: false,
      },
    },
    setup() {
      const { dispatch, getters } = useStore();
      const userStore = useUserStore();
      const store = useStore();
      const { toggle: fullscreenToggle } = useFullscreen();
      const route = useRoute();
      const personOnDuty = computed(() => store.state.app.personOnDuty);

      const userInfo = userStore.userInfo || {};

      const subsystemList = ref<TypeObject[]>([
        {
          label: 'C1航道',
          value: 'C1',
        },
        {
          label: 'C2航道',
          value: 'C2',
        },
        {
          label: 'C3航道',
          value: 'C3',
        },
        {
          label: 'C4航道',
          value: 'C4',
        }
      ]);
      const currentSubsystem = ref('C1');

      const logoutHandle = () => {
        userStore.logout();
      };
      const burialPoint = (name: any) => {
        console.log(name, route.meta.title);
        window.zhuge.track(name, {
          所在页面: route.meta.title,
        });
      };
      // 打开IT 报事地址
      const openIT = () => {
        console.log('openIT----')
        const url = 'https://itsm.longfor.com/quick-web/?sysId=244953&sourcesysId=227016&appKey=c0b99d3bf3a541518e83d039478c95e4&flowCode=TYFXJCPT#/'
        window.open(url,'_blank')
      }
      const noticeboard = ref();

      // 打开公告栏
      const openNotice = () => {
        console.log('openNotice----')
        noticeboard.value.viewallbulletin();
      }
      // 打开新手引导页面
      const openGuide = () => {
        window.open(envData.guidUrl)
      }
      const handleOpenChat = () => {
        if (personOnDuty.value){
          window.zhuge.track('快速咨询', {
            所在页面: route.meta.title,
          });
          const protocal = window.location.host === 'idata.longfor.com' ? 'longfor' : 'longforuat';
          window.location.href = `${protocal}://im/startChat?conversationType=1&account=${userInfo.oa}&userAccount=${personOnDuty.value}`;
        }
      }

      const useBreadcrumb = computed(() => getters.useBreadcrumb);

      const layout = computed(() => getters.layout);

      return {
        userInfo,
        envData,
        logoutHandle,
        burialPoint,
        openIT,
        openNotice,
        noticeboard,
        openGuide,
        handleOpenChat,
        useBreadcrumb,
        layout,
        subsystemList,
        currentSubsystem,
        changeSubsystem: (info:TypeObject) => {
          currentSubsystem.value = info.value;
          ElMessage({
            message: `切换 ${info.label} 的菜单`,
            type: 'warning',
            showClose: true,
          });
        },
        fullscreenToggle,
      };
    },
  });
</script>

<style lang="scss" scoped>
.navbar {
  @include flex-box();

  box-sizing: border-box;
  height: 100%;
  padding: 0 12px;

  .navbar-left {
    display: flex;
    flex: 1;
    align-items: center;

    .project-wrap {
      display: flex;
      align-items: center;

      .project-item {
        position: relative;
        height: 100%;
        margin: 0 18px;
        font-size: 12px;
        line-height: 28px;
        cursor: pointer;

        &.current {
          color: #FFF;
          font-weight: 700;

          &:after {
            position: absolute;
            bottom: 0;
            left: 0;
            width: 100%;
            height: 2px;
            background: #FFF;
            border-radius: 6px;
            box-shadow: 0 1px 3px rgba(20, 116, 243, 0.3);
            content: '';
          }
        }
      }
    }
  }

  .navbar-right {
    @mixin common {
      display: flex;
      align-items: center;
      height: $--btn-hover-height;
      padding: 0 10px;
      cursor: pointer;
    }

    @include flex-box(flex-end);

    .guide-new{
      display: flex;
      align-items: center;
      width: 76px;
      height: 18px;
      padding: 2px 10px;
      background: radial-gradient(150.48% 159.72% at 101.53% -34.54%, #F5FCFF 0%, #5BA4FF 43.53%, #0047FF 100%);
      border-radius: 22px;
      cursor: pointer;

      .itsm-icon{
        margin-right: 4px;
        color: #FFF;
        font-size: 18px;
      }

      .label {
        position: relative;
        top: -1px;
        color: #FFF;
        font-size: 12px;
        line-height: 18px;
        text-align: left;
      }
    }

    .guide{
      height: 22px;
      cursor: pointer;
    }

    .icon-label{
      color: #434C59;
      margin-left: 4px;
      font-size: 12px;
    }

    .navbar-right__icon {
      @include common();

      font-size: 20px;

      &.no-pr {
        padding-right: 0;
      }

      .text-size {
        font-size: 12px;
      }
    }

    .el-dropdown-link {
      @include common();
      padding: 0;
      margin-left: 10px;
      outline: none;

      .itsm-icon,
      .help-icon {
        margin-right: 0;
      }

      .username {
        min-width: 20px;
        padding: 0 4px;
      }
    }

    .el-icon-total{
      height: 28px;
      margin: 2px 4px;
      padding: 0 4px;
      &:hover{
        background: #E3EAF5;
        border-radius: 4px;
      }
    }

  }
}

.icon__username{
  font-size: 18px !important;
}

//.el-dropdown-menu__item{
//  &:hover{
//    background-color: #EFF3FA;
//  }
//}

.header__maia-default {
  .navbar-left {
    .project-wrap {
      .project-item {
        &.current {
          color: #007AF5;

          &:after {
            background: #007AF5;
            box-shadow: 0 1px 3px rgba(20, 116, 243, 0.3);
          }
        }
      }
    }
  }
}
</style>
<style>
.nav-btn-list{
  .el-dropdown-menu__item:not(.is-disabled):focus{
    background-color: #fff;
    color: #111;
  }
  .svg-icon{
    margin-right: 8px;
  }
}
</style>
